module.exports = __webpack_public_path__ + "static/media/to-kitchen.62a7eb7f.jpg";